<template>
  <el-tooltip
    effect="dark"
    :content="content"
    :placement="placement"
    :disabled="isShowTooltip"
    :popper-class="rows != 1 ? 'more-text-ellipsis-pop' : 'text-ellipsis-pop'"
  >
    <div
      :class="rows == 1 ? 'text-ellipsis' : 'more-text-ellipsis'"
      @mouseover="onMouseOver()"
    >
      <span ref="slotRef">
        <slot name="tips"></slot>
      </span>

      <span :ref="tooltipRef" class="tooltip-content">
        {{ content }}
        <span v-if="size" class="size">({{ size }})</span>
      </span>
    </div>
  </el-tooltip>
</template>
<script>
export default {
  name: "text-tooltip",
  props: {
    content: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
    tooltipRef: {
      type: String,
      default: "spanRef",
    },
    rows: {
      //行数
      type: Number,
      default: 1,
    },
    maxWidth: {
      //最大宽度
      type: Number,
      default: null,
    },
    placement: {
      type: String,
      default: "top",
    },
  },
  data() {
    return {
      isShowTooltip: false,
    };
  },
  methods: {
    onMouseOver() {
      // let refIndex = index || 0;
      // 内容超出，显示文字提示内容
      let tag = this.$refs[this.tooltipRef];
      let slotWidth = this.$refs.slotRef.offsetWidth || 0;
      if (this.rows == 1) {
        let parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
        let contentWidth = tag.offsetWidth + slotWidth; // 获取元素可视宽度
        if (this.maxWidth) {
          this.isShowTooltip = contentWidth <= this.maxWidth;
        } else {
          this.isShowTooltip = contentWidth <= parentWidth;
        }
      } else {
        this.isShowTooltip = true;
        let parentHeight = tag.parentNode.offsetHeight;
        let contentHeight = tag.offsetHeight;
        this.isShowTooltip = contentHeight <= parentHeight;
      }
    },
  },
};
</script>
<style scoped>
.text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.more-text-ellipsis {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.tooltip-content {
  /* vertical-align: middle; */
  line-height: 1.5;
}
</style>
<style>
.text-ellipsis-pop {
  max-width: calc(100vw - 260px);
}
.size {
  margin-left: 10px;
  color: #0d1b52;
  font-size: 12px;
  opacity: 0.3;
}
</style>
